<header class="mobile-header fixed-head">
    @if (notificationBarText()) {
      <app-notification-bar [content]="notificationBarText()"></app-notification-bar>
    }
  <div class="main">
    <div class="logo" [ngClass]="{ 'area-riservata-login-page': isAreaRiservataLoginPage() }">
      <a class="navbar-brand"
        [routerLink]="['']"
        (click)="checkRoutes()">
        <img src="assets/new_logo/redion_logo.svg" alt="europ assistance logo" width="190" height="33" />
      </a>
    </div>


    <div class="icon-container">
    <div class="icon">
      @if (!isAreaRiservataLoginPage()) {
        <div>
          @if (!isAreaRiservataLoginPage()) {
            <div class="icon" [ngClass]="{'user()': user()}" >
              @if (!user()) {
                <button type="button" class="mobile-header-icon-btn" aria-label="Accedi" (click)="openLoginModal()">
                  <i class="europe europe-user-outiline" aria-hidden="true"></i>
                </button>
              }
              @if (user()) {
                <button type="button" class="mobile-header-icon-btn" aria-label="Area clienti" (click)="openPrivateAreaModal()">
                  <i class="europe europe-user" aria-hidden="true"></i>
                </button>
              }
              <button type="button" class="mobile-header-icon-btn" aria-label="Apri menu" (click)="openModal()">
                <img src="../../../../../assets/img/menu-hb-mobile.svg" alt="" aria-hidden="true">
              </button>
            </div>
          }
        </div>
      }

    </div>
  </div>
</div>
@if (showRegistrationTooltip() && user()) {
  <div class="registration-tooltip-container">
    <div class="tooltip-box">
      <h4>Benvenuto {{ user().FirstName || user().Name }}</h4>
      @if (!showResetPasswordTooltip()) {
        <p>
          Clicca qui per accedere alla tua nuova area clienti per modificare i
          tuoi dati o visualizzare le tue polizze.
        </p>
      }
      @if (showResetPasswordTooltip()) {
        <p>Per resettare la tua password clicca qui
          <a (click)="removeResetItem()"
          [routerLink]="['/area-riservata/tuoi-dati/reset-password']">Reset Password</a>
        </p>
      }
    </div>
  </div>
}
</header>
